import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", { fill: "currentColor" }, [
      createElementVNode("path", { d: "M20.91 13.85H17.2a.25.25 0 0 1-.25-.24V9.89a1.49 1.49 0 0 0-3 0v3.72a.25.25 0 0 1-.25.24H3.09a3 3 0 0 0-3 3v2a3 3 0 0 0 2.74 3 .25.25 0 0 1 .23.25v.5a1.49 1.49 0 1 0 3 0V22a.25.25 0 0 1 .25-.25h11.38a.25.25 0 0 1 .25.25v.49a1.49 1.49 0 1 0 3 0V22a.25.25 0 0 1 .23-.25 3 3 0 0 0 2.74-3v-2a3 3 0 0 0-3-2.9M8.12 16.66A1.11 1.11 0 1 1 7 17.77a1.11 1.11 0 0 1 1.12-1.11M4.28 19a1.13 1.13 0 0 1-.71-.26 1.18 1.18 0 0 1-.48-.93 1.2 1.2 0 1 1 2.14.69 1.17 1.17 0 0 1-.95.5m6.98-13.31a1 1 0 0 0 0 1.4 1 1 0 0 0 1.4 0 4.07 4.07 0 0 1 5.6 0 1 1 0 0 0 .7.29.94.94 0 0 0 .7-.29 1 1 0 0 0 0-1.4 5.94 5.94 0 0 0-8.4 0" }),
      createElementVNode("path", { d: "M9.87 4.29a7.93 7.93 0 0 1 11.19 0 1 1 0 0 0 .7.29.94.94 0 0 0 .7-.29 1 1 0 0 0 0-1.4 9.9 9.9 0 0 0-14 0 1 1 0 0 0 1.4 1.4Z" })
    ], -1)
  ]));
}
const computerDeviceNetworkWifiRouter = { render };
export {
  computerDeviceNetworkWifiRouter as default,
  render
};
//# sourceMappingURL=computer-device-network-wifi-router.svg.js.map
